import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import AllBlogs from '../Components/AllBlogs'
import WhatsAppButton from '../Components/WhatsAppButton'

function Blogs() {
    return (
        <>
            <Navbar />
            <div className="Properties-header">
                <h1>All Blogs</h1>
                <p>
                    Home / <span className="active">Blogs</span>
                </p>
            </div>
            <br/>
            <AllBlogs/>
            <br/>
            <WhatsAppButton/>
            <Footer />
        </>
    )
}

export default Blogs